export default __webpack_public_path__ + "static/media/deal-12.a7bb783c.webp";